export default __webpack_public_path__ + "static/media/favicon.872bff9a.ico";